import { render, staticRenderFns } from "./Referer.vue?vue&type=template&id=3a600d18&scoped=true&"
import script from "./Referer.vue?vue&type=script&lang=js&"
export * from "./Referer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a600d18",
  null
  
)

export default component.exports